import React from 'react';
import { ArrowBackIos, Cancel } from '@mui/icons-material';
import {
  AppBar,
  Box,
  IconButton,
  Stack,
  Toolbar,
} from '@mui/material';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const TopNav = ({
  title,
  isGeneral,
  isAccount,
  screenWidth = 0,
}) => {
  const GlobalConstants = useContext(GlobalContext);
  const navigate = useNavigate();
  const userName = GlobalConstants.user;
  const patinet = JSON.parse(
    window.sessionStorage.getItem('patient')
  );
  const location = useLocation();
  const noBackLocations = [
    '/main/CurrentPatients',
    '/main/PatientList',
    '/main/SearchPatientForErja',
    '/main/ServiceReportSummary',
    '/TurnList',
    '/main/TurnList',
    '/main/LabTestResult',
    '/main',
    '/CurrentPatients',
    '/PatientList',
    '/SearchPatientForErja',
    '/ServiceReportSummary',
    '/LabTestResult',
    '/GetNewTurn',
    '/main/GetNewTurn',
    '/InvoiceReceipt',
    '/main/InvoiceReceipt',
    '/FreezeContract',
    '/main/FreezeContract',
    '/Quartering',
    '/main/Quartering',
    '/Lab',
    '/main/Lab',
    '/Pato',
    '/main/Pato',
    '/FileArchive',
    '/main/FileArchive',
    '/SendFileArchive',
    '/main/SendFileArchive',
    '/Wallet',
    '/main/Wallet',
    '/PatientSurveyList',
    '/Cartable',
    '/PatientsForVisit',
    '/main/PatientsForVisit',
    '/PatientsForVisitPreview',
    '/main/PatientsForVisitPreview',
    '/SavePatientsForVisit',
    '/main/SavePatientsForVisit',
    '/main/NobatPrefrences',
    '/main/WebAppSettings',
    '/WebAppSettings',
    '/NobatPrefrences',
    '/Home/GetReport',
    '/pacsImages',
    '/main/pacsImages',
  ];

  // console.log('topnav log=>', {
  //   patinet,
  //   userName,
  //   isAccount,
  // });

  return (
    <React.Fragment>
      <Box>
        <AppBar
          position="static"
          color="colorPrimer"
          sx={{
            borderRadius:
              screenWidth > 1024 ? '0 0 30px 30px' : '',
          }}
        >
          <Toolbar
            sx={{
              width: '100%',
              minHeight: 'unset',
            }}
          >
            <IconButton
              aria-label="بازگشت"
              sx={{
                color: `${themeColors.ColorSecondary} !important`,
              }}
              onClick={() => {
                if (
                  !noBackLocations.includes(
                    location.pathname
                  )
                ) {
                  navigate(-1);
                } else {
                  navigate('/main');
                }
                sessionStorage.removeItem('storedServices');
              }}
            >
              {screenWidth > 1024 ? (
                <Cancel />
              ) : (
                <ArrowBackIos />
              )}
            </IconButton>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                paddingRight: '5%',
                flexWrap: 'wrap',
                gap:
                  window.screen.width <= 410
                    ? '.5em'
                    : '1em',
              }}
            >
              <h4
                style={{
                  color: `${themeColors.ColorSecondary}!important`,
                }}
              >
                {title}
              </h4>
              {isGeneral !== true &&
                patinet !== undefined &&
                patinet !== false && (
                  <div
                    style={{
                      display: 'flex',
                      gap: '2em',
                      color: 'black',
                    }}
                  >
                    {isAccount !== undefined &&
                    userName !== undefined ? (
                      <p>
                        {ArabicToPersian(
                          userName?.FullName
                        )}
                      </p>
                    ) : screenWidth >= 1024 ? (
                      <Stack
                        sx={{
                          color: `${themeColors.ColorSecondary} !important`,
                          width: 'auto',
                          paddingInline: '1em',
                        }}
                        direction="row"
                        gap="1em"
                        borderRadius={'10px'}
                      >
                        <p>
                          {patinet?.NationalCodePatient}
                        </p>
                        <p>
                          {ArabicToPersian(
                            patinet?.FamilyPatient
                          )}
                        </p>
                        <p>
                          {ArabicToPersian(
                            patinet?.NamePatient
                          )}
                        </p>
                      </Stack>
                    ) : (
                      <Stack
                        sx={{
                          color: `${themeColors.ColorSecondary} !important`,
                          width: 'auto',
                        }}
                        direction="row"
                        gap="1em"
                      >
                        <p>
                          {patinet?.NationalCodePatient}
                        </p>
                        <p>
                          {ArabicToPersian(
                            patinet?.FamilyPatient
                          )}
                        </p>
                        <p>
                          {ArabicToPersian(
                            patinet?.NamePatient
                          )}
                        </p>
                      </Stack>
                    )}
                  </div>
                )}
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <Outlet />
    </React.Fragment>
  );
};

export default TopNav;
